var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"areaview"},[_c('div',{staticClass:"col"},[_c('span',{staticClass:"title"},[_vm._v("总清扫面积(平方米)")]),_c('countTo',{staticClass:"content",attrs:{"startVal":0,"endVal":_vm.entity.workArea,"duration":3000}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }